import { isClient, isSioHost } from '@systemeio/util'

export const isSIO = (hostOnServer?: string | null) =>
  isClient() ? isSioHost(window.location.host) : hostOnServer ? isSioHost(hostOnServer) : false
